import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { z } from "zod";
import TimerPage from "@/components/timer/timer-page";

const timerSearchSchema = z.object({
	date: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional(),
});

function TimerRoute(): JSX.Element {
	const { date } = Route.useSearch();
	return <TimerPage initialDateIso={date} />;
}

export const Route = createFileRoute("/_app/timer/")({
	component: TimerRoute,
	validateSearch: (search: Record<string, unknown>) => {
		const parsed = timerSearchSchema.safeParse(search);
		return parsed.success ? parsed.data : {};
	},
});
